import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";

export class MapKindLiteModel extends BaseObject {
  constructor(key = null, code = null) {
    super();
    this._key = key;
    this._code = code;
  }

  static schema() {
    return custom((v) => {
      if (!v) return SKIP;

      return serialize(MapKindLiteModel, v);
    }, (v) => {
      return deserialize(MapKindLiteModel, v);
    });
  }

  static keyOnlySchema() {
    return custom(
      (v) => {
        return v && v.key ? v.key : SKIP;
      },
      (v) => {
        if (typeof v === 'string') {
          return new MapKindLiteModel(v, null);
        } else if (typeof v === 'object' && v !== null) {
          return deserialize(MapKindLiteModel, v);
        } else {
          return null;
        }
      }
    );
  }

  static isNone(value) {
    return value instanceof MapKindLiteModel && value.key === "none";
  }

  get key() {
    return this._key;
  }
  set key(value) {
    this._key = value;
  }

  get code() {
    return this._code;
  }
  set code(value) {
    this._code = value;
  }

  copy() {
    let value = super.copy();
    value._enabled = false;
    return value;
  }

  clone(target = undefined) {
    if (!target) {
      return super.clone(new MapKindLiteModel());
    } else if (target instanceof MapKindLiteModel) {
      return super.clone(target);
    } else {
      console.log(false);
      return undefined;
    }
  }
}

createModelSchema(MapKindLiteModel, {
  _key: alias("key", Schema.primitive()),
  _code: alias("code", Schema.number())
});